import Banks from './Banks'

export default Banks
